import { Component, inject, OnInit } from '@angular/core';
import { ScheduleService } from '../../services/schedule.service';
import { ScheduleViewModel, ScheduleEvent } from '../../models/ScheduleModels';
//import moment from 'moment';
import moment from 'moment-timezone';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CalendarDayModel } from 'src/app/TeamSchedule/models/schedulemodels';
import { MatDialog } from '@angular/material/dialog';
import { AddEventDialogComponent } from '../add-event-dialog/add-event-dialog.component';
import { TimeZoneService } from 'src/app/shared/time-zone.service';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass, DatePipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'app-schedule-view',
  templateUrl: './schedule-view.component.html',
  styleUrls: ['./schedule-view.component.css'],
  imports: [MatToolbar, MatIconButton, MatIcon, MatProgressBar, NgClass, DatePipe]
})
export class ScheduleViewComponent implements OnInit {

  Days: Array<Date> = [];
  WeekIndex: Array<number> = [];
  DayActive: Array<boolean> = [];
  DayClass: Array<string> = [];
  daysOfMonth = [];
  schedule: ScheduleViewModel;
  currentYear: number;
  currentMonth: number;
  isLoading: boolean = false;
  currentTz: string;

  readonly dialog = inject(MatDialog);

  constructor(private scheduleService: ScheduleService, private tzService: TimeZoneService, public _router: Router, private _snackBar: MatSnackBar) { }

  ngOnInit() {

    var now = new Date();
    this.currentYear = now.getFullYear();
    this.currentMonth = now.getMonth();

    this.currentTz = this.tzService.getCurrentTimezone();

    this.getScheduleData();


  }

  openEventDetails(e: Event, event) {
    console.log(event);

    const dialogRef = this.dialog.open(AddEventDialogComponent, {
      data: {
        Event: event,
        isEditable: false
      },

      width: '600px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.getScheduleData();
      }
    });
  }

  addEvent(day: Date) {
    console.log(day);
    const dialogRef = this.dialog.open(AddEventDialogComponent, {
      data: {
        EventDate: day,
        Year: day.getFullYear(),
        Month: day.getMonth(),
        Date: day.getDate()

      },

      width: '600px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.getScheduleData();
      }
    });
  }

  getScheduleData() {
    this.isLoading = true;
    //console.log(this.currentYear + '-' + (this.currentMonth+1));
    this.scheduleService.getSchedule(this.currentYear, this.currentMonth + 1).subscribe(data => {
      this.schedule = data;
      console.log('StartDate:' + data.StartDateForMonth);
      console.log('StartDate date:' + new Date(data.StartDateForMonth));
      console.log('StartDate moment:' + moment(data.StartDateForMonth).toDate());
      console.log('EndDate:' + data.EndDateForMonth);
      //let a = moment([data.StartDateForMonth, 1, 1]);
      let a = moment(data.StartDateForMonthView);
      let b = moment.tz(data.EndDateForMonthView, this.currentTz);
      //let b = moment(data.EndDateForMonthView);
      let tempDate = a;
      console.log('StartDate tempdate:' + tempDate.toDate());
      let daysCount = b.diff(a, 'days');
      this.Days = [];
      this.DayClass = [];

    //console.log('*dayscount' + daysCount);
      for (let i = 0; i <= daysCount; i++) {

        this.Days.push(tempDate.toDate());

        var tmpClass = "calendar-day ";
        if (tempDate < moment(data.StartDateForMonth) || tempDate > moment(data.EndDateForMonth)) {
          tmpClass += " calendar-day-outofrange ";
        }
        if (tempDate.isSame(moment().toDate())) {
          tmpClass += " calendar-day-today ";
        }
        //console.log(tempDate);
        //console.log(moment().toDate());

        this.DayClass.push(tmpClass);


        tempDate = tempDate.add(1, 'day');

      }
      console.log(this.Days[5]);
      //console.log(this.schedule.EventList);
      this.isLoading = false;

    });
  }

  getEvents(day: Date): Array<ScheduleEvent> {
    /* console.log(this.schedule.EventList.filter( event=>{
      return moment(event.EventStart).isSame(moment(day), 'day');
    })); */

    //console.log(day);

    return this.schedule.EventList.filter(event => {

      return moment(event.EventStartUTC).isSame(moment(day), 'day');
    });
  }


  openGameDetails(GameId: string) {
    this._router.navigate(['/scouting/gamedetails', GameId]);

  }

  deleteEventFromCalendar(e: Event, EventId: string) {
    console.log(EventId);
    //e.stopPropagation();    
    this.scheduleService.removeEventFromSchedule(EventId).subscribe(res => {
      //console.log(res);
      this.openSnackBar("EVENT REMOVED", "CLOSE");
      this.getScheduleData();
    });


  }

  nextMonth() {
    var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 }).add(1, 'months');

    this.currentYear = m.year();
    this.currentMonth = m.month();

    this.getScheduleData();

  }

  previousMonth() {
    var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': 1 }).subtract(1, 'months');
    //console.log(m);
    this.currentYear = m.year();
    this.currentMonth = m.month();

    this.getScheduleData();

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


}
